/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Everyone_ConfirmedInputs */

const en_admin_dashboard_everyone_confirmed = /** @type {(inputs: Admin_Dashboard_Everyone_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone confirmed`)
};

const de_admin_dashboard_everyone_confirmed = /** @type {(inputs: Admin_Dashboard_Everyone_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle bestätigt`)
};

const es_admin_dashboard_everyone_confirmed = /** @type {(inputs: Admin_Dashboard_Everyone_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos confirmados`)
};

const fr_admin_dashboard_everyone_confirmed = /** @type {(inputs: Admin_Dashboard_Everyone_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout le monde confirmé`)
};

const nl_admin_dashboard_everyone_confirmed = /** @type {(inputs: Admin_Dashboard_Everyone_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iedereen bevestigd`)
};

const it_admin_dashboard_everyone_confirmed = /** @type {(inputs: Admin_Dashboard_Everyone_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti confermati`)
};

const pt_br2_admin_dashboard_everyone_confirmed = /** @type {(inputs: Admin_Dashboard_Everyone_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos confirmados`)
};

const pl_admin_dashboard_everyone_confirmed = /** @type {(inputs: Admin_Dashboard_Everyone_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszyscy są potwierdzeni`)
};

const hu_admin_dashboard_everyone_confirmed = /** @type {(inputs: Admin_Dashboard_Everyone_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindenki megerősítve`)
};

const ro_admin_dashboard_everyone_confirmed = /** @type {(inputs: Admin_Dashboard_Everyone_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toata lumea confirmata`)
};

/**
* | output |
* | --- |
* | "Everyone confirmed" |
*
* @param {Admin_Dashboard_Everyone_ConfirmedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_everyone_confirmed = /** @type {((inputs?: Admin_Dashboard_Everyone_ConfirmedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Everyone_ConfirmedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_everyone_confirmed(inputs)
	if (locale === "de") return de_admin_dashboard_everyone_confirmed(inputs)
	if (locale === "es") return es_admin_dashboard_everyone_confirmed(inputs)
	if (locale === "fr") return fr_admin_dashboard_everyone_confirmed(inputs)
	if (locale === "nl") return nl_admin_dashboard_everyone_confirmed(inputs)
	if (locale === "it") return it_admin_dashboard_everyone_confirmed(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_everyone_confirmed(inputs)
	if (locale === "pl") return pl_admin_dashboard_everyone_confirmed(inputs)
	if (locale === "hu") return hu_admin_dashboard_everyone_confirmed(inputs)
	return ro_admin_dashboard_everyone_confirmed(inputs)
});
export { admin_dashboard_everyone_confirmed as "admin.dashboard.everyone_confirmed" }